import { GridSortModel } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetMedicalCodesTypeEnum,
  MedicalCode,
  MedicalCodeControllerApi,
} from "../../services";
import { Identified } from "../../types/sdk-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface UseGetDataImportProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  searchKey: string;
  type?: GetMedicalCodesTypeEnum;
  active?: boolean;
  archive?: boolean;
  enabled?: boolean;
}

/**
 * @author rajkumar rathod
 */
export const useGetCataLogCode = ({
  pagination,
  gridSorting,
  searchKey,
  type,
  active,
  archive,
  enabled = true,
}: UseGetDataImportProps): useBaseContent<Identified<MedicalCode>> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;
  // const _skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "catalog-diagnosis-code-import",
      pageSize,
      pageIndex,
      searchKey,
      gridSorting,
      type,
      active,
      archive,
    ],
    refetchOnWindowFocus: false,

    placeholderData: keepPreviousData,
    enabled: enabled,
    queryFn: async () =>
      new MedicalCodeControllerApi(getConfigObject())
        .getMedicalCodes(
          pageIndex, //page number
          pageSize, //page size
          sortBy, //sortBy
          sortDirect, //sort
          type, //GetMedicalCodesTypeEnum
          active, //active
          archive, //archive
          undefined, //source
          searchKey //searchValue
          // undefined //xTENANTID
        )
        .then((res) => asPaginatedContent<Identified<MedicalCode>>(res?.data)),
  });
};

export default useGetCataLogCode;
